module.exports = __webpack_public_path__ + "static/media/CC-COL2_1iPXeiW0_6up-t9saTIgQ0f0pax0MXmnQ.49069679.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CC-COL2_1iPXeiW0_6up-t9saTIgQ0f0pax0MXmnQ
// module id = 777
// module chunks = 0